import { useFlags } from "launchdarkly-react-client-sdk";
import fraction from "src/api/fraction";
import { useQuery } from "src/lib";

export const usePostalScoreQuery = (postalCode?: string) => {
  const { appFlowUsePostalScoreCheck } = useFlags();
  return useQuery({
    queryKey: ["postalScore", postalCode],
    queryFn: () => (postalCode ? fraction.getPostalScore(postalCode) : null),
    enabled: appFlowUsePostalScoreCheck && !!postalCode,
  });
};
